<div class="fixed inset-0 z-50 grid place-items-center bg-black/50 backdrop-blur-sm px-4 py-16">
  <div class="mt-6 w-full max-w-[900px] max-h-[90vh] overflow-y-auto overflow-x-hidden rounded-2xl border border-border-color bg-white shadow-[0_12px_36px_var(--box-shadow-color)]">
    <header class="flex items-center justify-between bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-5 py-3 text-light-color">
      <div class="flex items-center gap-3">
        <i class="fa-regular fa-calendar-plus text-lg"></i>
        <h2 class="text-base font-semibold">Novo Agendamento</h2>
      </div>
      <button
        type="button"
        class="flex h-9 w-9 items-center justify-center rounded-full border border-white/30 bg-white/10 text-white transition hover:bg-white/20"
        (click)="handleCloseModal()">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </header>

    <div class="px-5 py-5">
      <form class="mx-auto w-full max-w-[900px] space-y-6" [formGroup]="formCreateAppointment">
        <section class="space-y-3">
          <h3 class="text-sm font-semibold text-dark-color">Dados do Cliente</h3>
          <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
            <label class="block text-sm text-dark-color">
              <span class="block mb-1">Nome</span>
              <input
                type="text"
                id="clientName"
                formControlName="clientName"
                class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>
            <label class="block text-sm text-dark-color">
              <span class="block mb-1">Telefone</span>
              <input
                type="tel"
                id="clientPhone"
                mask="(00) 00000-0000"
                (input)="handleMaskPhone()"
                formControlName="clientPhone"
                class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>
            <label class="md:col-span-2 block text-sm text-dark-color">
              <span class="block mb-1">Documento</span>
              <input
                type="text"
                id="clientDocument"
                placeholder="CPF/CNPJ"
                formControlName="clientDocument"
                class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>
          </div>
        </section>

        <section class="space-y-3">
          <h3 class="text-sm font-semibold text-dark-color">Detalhes do Agendamento</h3>
          <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
            <label class="md:col-span-2 block text-sm text-dark-color">
              <span class="block mb-1">Data</span>
              <input
                type="date"
                id="date"
                formControlName="date"
                [readOnly]="formCreateAppointment.value.date"
                class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>
            <label class="block text-sm text-dark-color">
              <span class="block mb-1">Início</span>
              <input
                type="time"
                id="startTime"
                formControlName="startTime"
                [readOnly]="formCreateAppointment.value.startTime"
                class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
            </label>
            <label class="block text-sm text-dark-color">
              <span class="block mb-1">Término</span>
              <input
                type="time"
                id="endTime"
                formControlName="endTime"
                [readOnly]="formCreateAppointment.value.endTime"
                class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus-border-primary-color" />
            </label>
          </div>
        </section>

        <section class="space-y-3">
          <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
            <label class="block text-sm text-dark-color">
              <span class="block mb-1">Origem</span>
              <select
                id="origin"
                formControlName="origin"
                class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color">
                <option value="Whatsapp">Whatsapp</option>
                <option value="Telefone">Telefone</option>
                <option value="Instagram">Instagram</option>
                <option value="Email">Email</option>
                <option value="Facebook">Facebook</option>
                <option value="Outro">Outro</option>
              </select>
            </label>

            <label class="block text-sm text-dark-color">
              <span class="block mb-1">Status</span>
              <select
                id="status"
                class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus-border-primary-color">
                <option value="scheduled" selected>Agendado</option>
                <option value="pending">Pendente</option>
                <option value="cancelled">Cancelado</option>
                <option value="confirmed">Confirmado</option>
              </select>
            </label>
          </div>

          <label class="block text-sm text-dark-color">
            <span class="block mb-1">Observações</span>
            <textarea
              id="notes"
              rows="2"
              formControlName="notes"
              class="mt-1 w-full max-h-48 rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color overflow-y-auto"></textarea>
          </label>
        </section>

        <div class="flex flex-col gap-2 border-t border-border-color pt-3 md:flex-row md:justify-end">
          <button
            type="button"
            class="inline-flex items-center justify-center gap-2 rounded-base border border-border-color bg-white px-4 py-2 text-sm font-semibold text-dark-color shadow-sm transition hover:border-primary-color"
            (click)="handleCloseModal()">
            <i class="fa-solid fa-xmark"></i>
            Cancelar
          </button>
          <button
            type="button"
            class="inline-flex items-center justify-center gap-2 rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white shadow transition hover:bg-primary-hover"
            (click)="handleSubmit()">
            <i class="fa-solid fa-check"></i>
            Salvar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<app-alert></app-alert>
<app-loading-modal></app-loading-modal>
